import { render, staticRenderFns } from "./InvoicePlain.vue?vue&type=template&id=0e87907a&"
import script from "./InvoicePlain.vue?vue&type=script&lang=js&"
export * from "./InvoicePlain.vue?vue&type=script&lang=js&"
import style0 from "./InvoicePlain.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports